import { VIEWED_FROM } from "./types";

export const updateViewed = (viewedFrom) => (dispatch) => {
  dispatch({ type: VIEWED_FROM, payload: viewedFrom });
};
